import { render, staticRenderFns } from "./BlackInputPeopleNumV2.vue?vue&type=template&id=0bda9737&scoped=true"
import script from "./BlackInputPeopleNumV2.vue?vue&type=script&lang=js"
export * from "./BlackInputPeopleNumV2.vue?vue&type=script&lang=js"
import style0 from "./BlackInputPeopleNumV2.vue?vue&type=style&index=0&id=0bda9737&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bda9737",
  null
  
)

export default component.exports